import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AppSvgIcons } from '@thehubz/client/core';

@Component({
  selector: 'lh-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    const logoPath = 'assets/logos';
    const iconPath = 'assets/icons';

    const customSvgIcons = {
      'sp-brand': `${logoPath}/SP_LOGO_RGB.svg`,
      'sp-makeos-white': `${logoPath}/SP_MAKEOS_Logo_White.svg`,
      'sp-makeos-black': `${logoPath}/SP_MAKEOS_Logo_black.svg`,
      image_icon: `${iconPath}/Photo.svg`,
      overview_menu_icon: `${iconPath}/Tiles.svg`,
      companies_menu_icon: `${iconPath}/Office_building.svg`,
      groups_menu_icon: `${iconPath}/Edit_profile.svg`,
      users_menu_icon: `${iconPath}/Profile.svg`,
      tags_menu_icon: `${iconPath}/Price_tag.svg`,
      teams_menu_icon: `${iconPath}/People_group.svg`,
      tasks_menu_icon: `${iconPath}/Virus_test_certificate_positive.svg`,
      tools: `${iconPath}/Aircraft_mechanic.svg`,
      maintenance_icon: `${iconPath}/Aircraft_mechanic.svg`,
      LH_asset_uploaded_icon: `${iconPath}/LH_uploaded.svg`,
      LH_asset_awaiting_approval_icon: `${iconPath}/LH_awaiting_approval.svg`,
      LH_delete_icon: `${iconPath}/Delete.svg`,
      LH_save_icon: `${iconPath}/Save.svg`,
    };

    const svgIcons = Object.assign({}, AppSvgIcons, customSvgIcons);

    for (const [iconName, iconSrc] of Object.entries(svgIcons)) {
      iconRegistry.addSvgIcon(iconName, sanitizer.bypassSecurityTrustResourceUrl(iconSrc));
    }
  }
}
